import { createTheme } from '@mui/material/styles';
import { grey, deepPurple } from '@mui/material/colors';
import * as Constants from 'common/Constants';

export const defaultTheme = createTheme({
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          paddingTop: '1.5rem',
          paddingBottom: '2rem',
          paddingLeft: '1.5rem',
          paddingRight: '1.5rem',
          margin: 2,
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          backgroundColor: grey[200],
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: 'h4' },
          style: {
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: 'black',
          },
        },
        {
          props: { variant: 'h5' },
          style: {
            fontSize: '1.25rem',
            fontWeight: 'bold',
            color: Constants.PRIMARY_DARK,
          },
        },
        {
          props: { mystyle: 'paraHeader' },
          style: {
            color: 'black',
            paddingBottom: '6px',
          },
        },
        {
          props: { mystyle: 'pageHeader' },
          style: {
            color: 'black',
            paddingBottom: '40px',
          },
        },
        {
          props: { variant: 'h6' },
          style: {
            fontSize: '1rem',
            fontWeight: 'bold',
            color: Constants.PRIMARY,
          },
        },
        {
          props: { variant: 'body1' },
          style: {
            fontSize: '1rem',
          },
        },
        {
          props: { mystyle: 'download' },
          style: {
            fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif', 'Times'],
          },
        },
        {
          props: { mystyle: 'stepper' },
          style: {
            color: Constants.PRIMARY_DARK,
          },
        },
      ],
    },
    MuiGrid: {
      variants: [
        {
          props: { variant: 'addPaddingBottom' },
          style: {
            paddingBottom: '0.5rem',
          },
        },
      ],
    },
  },
  palette: {
    background: {
      default: Constants.DEFAULT_BACKGROUND,
      white: Constants.WHITE,
    },
    primary: {
      main: Constants.PRIMARY,
      dark: Constants.PRIMARY_DARK,
      userName: deepPurple[500],
      spinner: Constants.DEFAULT_SPINNER,
      maskBox: Constants.DEFAULT_MASKBOX,
    },
    charts: {
      censusMale: Constants.CENSUS_MALE,
      censusFemale: Constants.CENSUS_FEMALE,
      censusOther: Constants.CENSUS_OTHER,
      spouseRelationship: Constants.SPOUSE_RELATIONSHIP,
      benchmarkMale: Constants.BENCHMARK_MALE,
      benchmarkFemale: Constants.BENCHMARK_FEMALE,
      benchmarkOther: Constants.BENCHMARK_OTHER,
    },
  },
});

export const alliantTheme = createTheme({
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          paddingTop: '1.5rem',
          paddingBottom: '2rem',
          paddingLeft: '1.5rem',
          paddingRight: '1.5rem',
          margin: 2,
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          backgroundColor: grey[200],
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: 'h4' },
          style: {
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: 'black',
          },
        },
        {
          props: { variant: 'h5' },
          style: {
            fontSize: '1.25rem',
            fontWeight: 'bold',
            color: Constants.PRIMARY_DARK_ALLIANT,
          },
        },
        {
          props: { mystyle: 'paraHeader' },
          style: {
            color: 'black',
            paddingBottom: '6px',
          },
        },
        {
          props: { mystyle: 'pageHeader' },
          style: {
            color: 'black',
            paddingBottom: '40px',
          },
        },
        {
          props: { variant: 'h6' },
          style: {
            fontSize: '1rem',
            fontWeight: 'bold',
            color: Constants.PRIMARY_ALLIANT,
          },
        },
        {
          props: { variant: 'body1' },
          style: {
            fontSize: '1rem',
          },
        },
        {
          props: { mystyle: 'download' },
          style: {
            fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif', 'Times'],
          },
        },
        {
          props: { mystyle: 'stepper' },
          style: {
            color: Constants.PRIMARY_DARK_ALLIANT,
          },
        },
      ],
    },
    MuiGrid: {
      variants: [
        {
          props: { variant: 'addPaddingBottom' },
          style: {
            paddingBottom: '0.5rem',
          },
        },
      ],
    },
  },
  palette: {
    background: {
      default: Constants.ALLIANT_BACKGROUND,
      white: Constants.WHITE,
    },
    primary: {
      main: Constants.PRIMARY_ALLIANT,
      dark: Constants.PRIMARY_DARK_ALLIANT,
      contrastText: Constants.WHITE,
      userName: Constants.PRIMARY_DARK_ALLIANT,
      spinner: Constants.PRIMARY_ALLIANT_LIGHT,
      maskBox: Constants.PRIMARY_ALLIANT_LIGHT,
    },
    charts: {
      censusMale: Constants.PRIMARY_DARK_ALLIANT,
      censusFemale: Constants.PRIMARY_ALLIANT,
      censusOther: Constants.CENSUS_OTHER_ALLIANT,
      spouseRelationship: Constants.CENSUS_OTHER_ALLIANT,
      benchmarkMale: Constants.BENCHMARK_MALE_ALLIANT,
      benchmarkFemale: Constants.BENCHMARK_FEMALE_ALLIANT,
      benchmarkOther: Constants.BLACK,
    },
  },
});
